import React from 'react';
import { PropTypes } from 'prop-types';

const LoadingWrapper = ({ children, loaded, message }) => {
  if (!loaded) {
    return (
      <div className="loader">
        <div>
          <div>
            <div className={ `sk-fading-circle ${ message ? 'show-message' : '' }` }>
              <div className="sk-circle1 sk-circle" />
              <div className="sk-circle2 sk-circle" />
              <div className="sk-circle3 sk-circle" />
              <div className="sk-circle4 sk-circle" />
              <div className="sk-circle5 sk-circle" />
              <div className="sk-circle6 sk-circle" />
              <div className="sk-circle7 sk-circle" />
              <div className="sk-circle8 sk-circle" />
              <div className="sk-circle9 sk-circle" />
              <div className="sk-circle10 sk-circle" />
              <div className="sk-circle11 sk-circle" />
              <div className="sk-circle12 sk-circle" />
            </div>
            { message != null && message !== '' && <div className="loader-message">{ message }</div> }
          </div>
        </div>
      </div>
    );
  }
  return (
    <div>
      { children }
    </div>
  );
};

LoadingWrapper.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  loaded: PropTypes.bool.isRequired,
  message: PropTypes.string
};

LoadingWrapper.defaultProps = {
  children: null,
  message: null
};

export default LoadingWrapper;
